import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toPhotoData = (data: unknown): PhotoWorkflowData => {
    return {
        company: get(data, 'company'),
        photoId: get(data, 'photoId'),
        skipPhoto: get(data, 'skipPhoto'),
        workflow: toWorkflowData(data),
        workflowType: 'photo',
        user: get(data, '_embedded.user'),
    }
}
